import { createReducer } from '@reduxjs/toolkit';
import { loadFormData } from "../../actions/form";
export const defaultEntryTypesConfig = {
  [loadFormData]: (state, action) => {
    const {
      entryTypes
    } = action.payload;
    return entryTypes;
  }
};
export const entryTypesReducer = createReducer([], defaultEntryTypesConfig);